export default {
  GET_USER_INFO (state, data) {
    state.me = Object.assign({}, state.me, data)
  },
  GET_REDIRECT_PATH (state, data) {
    state.redirectPath = data
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js